import React from 'react';
import NumberFormat from 'react-number-format';

// Components
import Inputs from '@components/UI-KIT/Filters/Inputs';

// Styles
import './AmountFilter.scss';

interface Props {
    value: number;
    label: string;
    onChange: (_value: number) => void;
}

const AmountFilter: React.FC<Props> = ({ label, value, onChange }) => (
    <Inputs
        label={label}
        className="ui-AmountFilter"
    >
        <NumberFormat
            value={value}
            isNumericString
            decimalScale={2}
            allowNegative
            prefix="$"
            thousandSeparator="."
            decimalSeparator=","
            onValueChange={values => onChange(values.floatValue) }
        />
    </Inputs>
);

export default AmountFilter;
